export default {
  NewHoldingAdd: 'هولدینگ جدید اضافه شد',
  HoldingRemoved: 'هولدینگ حذف شد',
  UpdateHolding: 'هولدینگ بروزرسانی شد',
  LicensesRemoved: 'مجوز حذف شد',
  LicensesUpdate: 'شناسه مجوز بروزرسانی شد',
  NewLicensesAdd: 'شناسه مجوز جدید اضافه شد',
  NewCompanyAdd: 'باربری جدید اضافه شد',
  UpdateCompany: 'باربری بروزرسانی شد',
  CompanyRemoved: 'باربری حذف شد',

  Brand: 'نام تجاری',
  CompanyName: 'نام باربری',
  Companys: 'باربری ها',
  MobileConfimed: 'تایید تلفن همراه',
  Description: 'شرح',
  Enable: 'فعال',
  Email: 'ایمیل',
  EmailConfirmed: 'تایید ایمیل',
  EconomicCode: 'کد اقتصادی',
  Fax: 'نمابر',
  Disable: 'غیر فعال',
  Slug: 'Slug',
  ExpireTime: 'تاریخ انقضاء',
  StartTime: 'تاریخ شروع',
  Order: 'ترتیب',
  IsicCode: 'کدIsic',
  HoldingName: 'نام هلدینگ',
  Holding: 'هلدینگ',
  Mobile: 'تلفن همراه',
  NationalId: 'شناسه ملی',
  NegotiatorName: 'نام رابط',
  negotiatorLastName: 'نام خانوادگی رابط',
  NegotiatorMobile: 'موبایل رابط',
  LicensesType: 'نوع مجوز',
  licenseCategory: 'دسته مجوز',
  GuildId: 'انجمن صنفی',
  LicenseId: 'صاحب مجوز',
  Licenses: 'مجوز ها',
  LicenseType: 'نوع مجوز',
  NeedLicense: 'مجوز نیاز است',
  Phone: 'تلفن',
  OwnerId: 'مالک',
  Website: 'وبسایت',
  ApproveCompany: 'تایید باربری',
  AreYouSureYouWantToApproveThisCompany:
    'آیا مطمئن هستید که میخواهید این باربری را تایید کنید؟',
  CompanyApproved: 'باربری تایید شد',
  ApproveStatus: 'وضعیت تایید',
  Approved: 'تایید شده',
  Unapproved: 'تایید نشده',
  Operators: 'اپراتور ها',
  relatedCities: 'شهر های مرتبط',
  listOfRelatedCities_origin: 'لیست شهر های مرتبط (مبدا)',
  cities: 'شهر ها',
  drivers: 'راننده ها',
  legalInformation: 'اطلاعات حقوقی',
  negotiatorInformation: 'اطلاعات رابط',
  registrationNumber: 'شماره ثبت',
  companyInformation: 'اطلاعات باربری',
  editCompany: 'ویرایش باربری',
  gotoCompaniesList: 'رفتن به لیست باربری ها',
  companyDetail: 'جزئیات باربری',
  editCompanySupport: 'ویرایش پشتیبانی باربری',
  selectProvince: 'انتخاب استان',
  atLeastSelectOneCity: 'حداقل یک شهر انتخاب کنید',
  loadSupport: 'پشتیبانی نوع بار',
  tariff: 'تعرفه ها',
  companyLoadSupportedType: 'نوع بار پشتیبانی شده',

  brand: 'نام تجاری',
  negotiatorName: 'نام رابط',
  negotiatorMobile: 'موبایل رابط',
  website: 'وبسایت',
  approveStatus: 'وضعیت تایید',
  phone: 'تلفن',
  approved: 'تایید شده',
  unapproved: 'تایید نشده',
  companyName: 'نام باربری',
  economicCode: 'کد اقتصادی',
  nationalId: 'شناسه ملی',
  fax: 'نمابر',
  owner: 'مالک',
  holding: 'هلدینگ',
  operators: 'اپراتور ها',
  companies: 'باربری ها',
  company: 'باربری',
  licensee: 'صاحب مجوز',
  guildAssociation: 'انجمن صنفی',
  contractor: 'مشخصات پیمانکار',
  employer: 'مشخصات کارفرما',
  employerName: 'نام کارفرما',
  contractorName: 'نام پیمانکار',
  contractorNationalId: 'کد ملی پیمانکار',
  employerNationalId: 'کد ملی کارفرما',
  employerType: 'نوع کارفرما',
  contractorType: 'نوع پیمانکار',
  contractorMobile: 'موبایل پیمانکار',
  employerMobile: 'موبایل کارفرما',
  employerRegistrationNumber: 'شماره ثبت کارفرما',
  contractorRegistrationNumber: 'شماره ثبت پیمانکار',
  duration: 'مدت',
  employerAddress: 'آدرس کارفرما',
  contractorAddress: 'آدرس پیمانکار',
  companyPage: 'صفحه باربری',
  companyTemplatePage: 'صفحه الگوی باربری',
  domains: 'دامنه ها',
  noDomainAddedYet: 'هنوز دامنه / زیر دامنه ای اضافه نشده',
  subject: 'موضوع',
  signatories: 'امضا کنندگان',
  sign: 'حق امضا',
  noSignatoryAddedYet: 'هنوز امضاکننده ای اضافه نشده است',
  profession: 'سمت',
  signatory: 'امضا کننده',
  companyId: 'شناسه باربری',
  contactInformation: 'اطلاعات تماس',
  instagram: 'اینستاگرام',
  linkedin: 'لینکداین',
  twitter: 'توییتر',
  facebook: 'فیس بوک',
  youtube: 'یوتویوب',
  aparat: 'آپارات',
  expertiseId: 'شناسه حوزه کاری',
  equipmentId: 'شناسه تجهیزات',
  contractCategoryId: 'شناسه دسته قرارداد',
  companyApproved: 'باربری تایید شد',
  approveCompany: 'تایید باربری',
  licenses: 'مجوز ها',
  urbanTariff: 'تعرفه شهری',
  intercityTariff: 'تعرفه بین شهری (مزایده)',
  cargoAuctionTariff: 'تعرفه مزایده',
  gatewayEditedSuccessfully: 'درگاه با موفقیت ویرایش شد',
  addToBlackList: 'افزودن به لیست سیاه',
  removeFromBlackList: 'حذف از لیست سیاه',
  areYouSureToRemoveThisDriverFromBlackList:
    'آیا از حذف این راننده از لیست سیاه اطمینان دارید؟',
  driverSuccessfullyRemovedFromBlackList: 'راننده از لیست سیاه حذف شد',
  driverSuccessfullyAddedToBlackList: 'راننده به لیست سیاه افزوده شد',
  areYouSureToRemoveThisCourierFromBlackList:
    'آیا از حذف این باربری از لیست سیاه اطمینان دارید؟',
  courierSuccessfullyRemovedFromBlackList: 'باربری از لیست سیاه حذف شد',
  courierSuccessfullyAddedToBlackList: 'باربری به لیست سیاه افزوده شد',
  contractNumber: 'شماره قرارداد',
  serviceType: 'نوع سرویس',
  driverTypes: 'نوع راننده',
  reserve: 'رزرو',
  available: 'در اختیار',
  selectedDrivers: 'راننده های انتخاب شده',
  serviceSpecification: 'مشخصات سرویس',
  driverSpecification: 'مشخصات راننده',
  contractSpecification: 'مشخصات قرارداد',
  bolCommission: 'کمیسیون صدور بارنامه'
}
